import React, { Component } from 'react';
import posed, { PoseGroup } from 'react-pose';

const MoveDiv = posed.div({
  exit: {
    opacity: 0
  },
  enter: {
    opacity: 1
  }
});

class Modal extends Component {

  state = {
    children: null
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if(this.props.children !== prevProps.children){
      if(this.state.children === null){
        this.setState({children: this.props.children});
      } else if (this.props.children !== prevProps.children) {
        this.setState({children: null});
        setTimeout(() => this.setState({children: this.props.children}), 300)
      }
    }
  }


  render() {
    const { closeModal } = this.props;
    const { children } = this.state;
    return (
      <PoseGroup>
        {
          children !== null &&
          <MoveDiv style={{ zIndex: 4000 }} className="fixed-top" key="modal">
            <div onClick={closeModal}
                 style={{ zIndex: 4000, opacity: 0.8, backgroundColor: "rgba(255,255,255,0.24)" }}
                 className="container-fluid fixed-top vh-100">
            </div>
            <div style={{ top: 0 }} className="container-fluid position-absolute vh-100">
              <div className="row h-100 justify-content-center align-items-center px-2">
                <div style={{ zIndex: 4001, maxHeight: "90vh" }} className="col-auto position-fixed shadow overflow-auto">
                  <div className="row">
                    {children}
                  </div>
                </div>
              </div>
            </div>
          </MoveDiv>
        }
      </PoseGroup>
    );
  }
}

export default Modal;
